import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Case} from "../../../../../../../../../_base-shared/models/Case/Case";
import {ScheduleDialerCase} from "../../../../../../../../../_base-shared/models/Dialer/ScheduleDialerCase";
import {Subscription} from "rxjs";
import {CaseService} from "../../../../case.service";
import {finalize} from "rxjs/operators";

@Component({
  selector: 'app-dialer-history-log',
  templateUrl: './dialer-history-log.component.html',
  styleUrls: ['./dialer-history-log.component.scss'],
  standalone: false
})
export class DialerHistoryLogComponent implements OnInit, OnDestroy{
  @Input() case: Case;
  public isLoading = 0;
  public dialerCallRequests: Array<ScheduleDialerCase>;
  private subscriptions: Array<Subscription> = [];

  constructor(private caseService: CaseService) {
  }

  ngOnInit(): void {
    this.fetchLogs(this.case.id);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  private fetchLogs(caseId: number): void {
    this.isLoading++;
    this.subscriptions.push(
      this.caseService.getDialerHistoryLogs(caseId, { select_all: 1, only_completed: 1, sort_order: 'desc' }).pipe(finalize(() => this.isLoading--)).subscribe({
          next: result => {
            this.dialerCallRequests = result.data;
            console.log(this.dialerCallRequests);
          },
          error: error => console.error(error),
        }
      ),
    );
  }
}

